"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BoldReportsReportViewerPageActions;
(function (BoldReportsReportViewerPageActions) {
    BoldReportsReportViewerPageActions["Loaded"] = "Loaded";
})(BoldReportsReportViewerPageActions || (BoldReportsReportViewerPageActions = {}));
exports.default = BoldReportsReportViewerPageActions;
